export const MARKETING_EMAILS: string[] = [
	'rustam.n@investlink.io',
	'pavel.s@investlink.io'
]
